import { useState } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "urql";
import Page from "../Page";
import urls from "../../routes";
import { getFragmentData, graphql } from "../../__generated__/gql";
import NotFound from "../NotFound/NotFound";
import Badge from "../../ui/Badge/Badge";
import Tabs from "../../ui/Tabs/Tabs";
import AdminArticleViewer from "./AdminArticleViewer";
import styles from "./AdminArticle.module.scss";

const AdminArticlePageAdminArticle = graphql(/* GraphQL */ `
  fragment AdminArticlePage on AdminArticle {
    id
    title
    version
    versions
    type
    body
    bodyHtml
    bodyText
    excerpt
    metaDescription
    processingMessage
    status
    heroImage {
      ...ArticleImage
    }
    tag {
      id
      name
    }
    ...AdminArticleViewer
    # ...ArticleEditor
    # ...ArticleDetails
    # ...StatusBadge
  }
`);

const AdminArticleQuery = graphql(/* GraphQL */ `
  query adminArticle($id: String!) {
    adminArticle(id: $id) {
      ...AdminArticlePage
    }
  }
`);

function Article() {
  const { id } = useParams<{ id: string }>();
  const [activeTab, setActiveTab] = useState<string>("editor");

  const [articleResponse] = useQuery({
    query: AdminArticleQuery,
    variables: { id: id! },
    pause: !id,
    requestPolicy: "network-only",
  });

  const article = getFragmentData(
    AdminArticlePageAdminArticle,
    articleResponse.data?.adminArticle,
  );

  if (!article && !articleResponse.fetching) {
    return <NotFound />;
  }

  const breadcrumbs = [{ name: "Articles", url: urls.admin.articles }];

  return (
    <>
      <Page
        className={styles.pageContainer}
        loading={articleResponse.fetching || !articleResponse.data}
        title={
          !articleResponse.fetching
            ? (article?.title ?? (
                <Badge
                  variant="pill"
                  color="default"
                  size="small"
                  showDot={false}
                  loading
                />
              ))
            : null
        }
        documentTitle={article?.title ?? "Article"}
        fullHeight
        breadcrumbs={articleResponse.fetching ? [] : breadcrumbs}
        buttons={
          article
            ? [
                ...(article.version && article.versions > 1
                  ? [
                      {
                        type: "dropdown" as const,
                        variant: "outline" as const,
                        children: `v${article.version}`,
                        items: [
                          {
                            items: Array.from(
                              {
                                length: article.versions,
                              },
                              (v, i) => article.versions - i,
                            ).map((v) => ({
                              label:
                                v === article.version
                                  ? `v${v} (selected)`
                                  : `v${v}`,
                              onClick: async () => {},
                              // onClick: async () => await setArticleVersion({
                              //   id: article.id,
                              //   version: v,
                              // }),
                            })),
                          },
                        ],
                      },
                    ]
                  : []),
              ]
            : undefined
        }
      >
        {article ? (
          <>
            <div className={styles.page}>
              {/* <div className={styles.pageLeft}> */}
              <Tabs
                classNames={{
                  list: styles.tabs,
                  content: styles.tabContent,
                }}
                value={activeTab}
                onValueChange={setActiveTab}
                tabs={[
                  {
                    id: "editor",
                    label: "Article",
                    content: <AdminArticleViewer data={article} />,
                  },
                ]}
              />
              {/* </div> */}
              {/* <div className={styles.pageRight}>
                <ArticleDetails article={article} />
              </div> */}
            </div>
          </>
        ) : null}
      </Page>
    </>
  );
}

export default Article;
